var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disabled,
              expression: "!disabled"
            }
          ],
          staticStyle: { padding: "5px 0" }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.showEditDialog(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.showEditDialog(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.remove } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "350px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.finalRowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c("div", { staticStyle: { padding: "5px 0", "font-size": "12px" } }, [
        _c("span", { staticStyle: { color: "#0a0aff" } }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.freightChargesUSDTotal")))
        ]),
        _c(
          "i",
          { staticStyle: { "margin-left": "15px", "margin-right": "5px" } },
          [_vm._v(_vm._s(_vm.cargoDoc.freightChargeEnUpper))]
        ),
        _c("i", [
          _vm._v(
            "(" +
              _vm._s(
                _vm.NumberUtils.formatNumber(_vm.cargoDoc.freightChargeTotal, 2)
              ) +
              ")"
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "freight-charges-info-dialog",
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "465px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-width": "100px", "label-position": "right" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ChargeItem") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "chargeItemId",
                          "select-type": _vm.TYPE_NAMES.basic_data_ChargeItem,
                          filterable: "",
                          "default-value":
                            _vm.editDialog.form.chargeItemId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.chargeItemId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ChargeClause") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "paymentTermHBL",
                          "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                          filterable: "",
                          "default-value": _vm.editDialog.form.paymentTermHBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.paymentTermHBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Currency") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "currency",
                          "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                          filterable: "",
                          "default-value": _vm.editDialog.form.currency
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.currency = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "eqSize",
                          "select-type": _vm.TYPE_NAMES.local_cache_EQSize,
                          headers: [_vm.$t("SeaExport.Code2")],
                          fields: ["code"],
                          filterable: "",
                          "default-value": _vm.editDialog.form.eqSize,
                          "tag-name": "code"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.eqSize = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContainerType") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "eqType",
                          "select-type": _vm.TYPE_NAMES.basic_data_EQType,
                          headers: [_vm.$t("SeaExport.Code2")],
                          fields: ["code"],
                          filterable: "",
                          "default-value": _vm.editDialog.form.eqType,
                          "tag-name": "code"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.eqType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Quantity2") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "quantity",
                          precision: 0,
                          controls: false
                        },
                        on: {
                          change: function(p) {
                            _vm.caculateAmount()
                            _vm.changeBillOfLadingSynJob()
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "quantity", $$v)
                          },
                          expression: "editDialog.form.quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UnitRate") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "unitRate",
                          precision: 2,
                          controls: false
                        },
                        on: { change: _vm.caculateAmount },
                        model: {
                          value: _vm.editDialog.form.unitRate,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "unitRate", $$v)
                          },
                          expression: "editDialog.form.unitRate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Amount") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { no: "amount", precision: 2, controls: false },
                        on: {
                          change: function($event) {
                            _vm.editDialog.form.unitRate =
                              _vm.editDialog.form.amount
                          }
                        },
                        model: {
                          value: _vm.editDialog.form.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "amount", $$v)
                          },
                          expression: "editDialog.form.amount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }